import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

// Seat map for one shift night (seat booking restaurants). Chair states only:
// 'available' or 'taken' (paid for, or booked by staff). An unpaid booking does
// not take its chairs.
export const getSeatMap = async (restaurantId, date, shiftId) => {
  const response = await axios.get(`${BASE_API}/public/seat-map/restaurant/${restaurantId}`, {
    params: { date, ...(shiftId ? { shiftId } : {}) },
  });
  return response.data;
};
